/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.temp.dereferenceScope'

export { $nsid }

/** Allows finding the oauth permission scope from a reference */
const main = l.query(
  $nsid,
  l.params({ scope: l.string() }),
  l.jsonPayload({ scope: l.string() }),
  ['InvalidScopeReference'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
